export default __webpack_public_path__ + "static/media/Facebook.fde8f447.svg";